import React, { useEffect, useState } from 'react';
import { Box, makeStyles, Divider, Card, CardHeader } from '@material-ui/core';
import Page from 'src/components/Page';
import qs from 'qs';
import { connect } from 'react-redux';
// import PropTypes from 'prop-types';
import alertSnackbarActions from 'src/store/actions/alertSnackbarActions';
import storage from 'src/storage';
import config from 'src/config';
import { useLocation } from 'react-router-dom';
import api from 'src/services/httpService';
import Results from './Results';
import Toolbar from './Toolbar';

const ActivityLogView = () => {
  const { pathname } = useLocation();
  console.log(pathname);
  const [pagination, setPagination] = useState({});
  const [data, setData] = useState([]);
  const location = useLocation();

  const useStyles = makeStyles(theme => ({
    root: {
      backgroundColor: theme.palette.background.dark,
      minHeight: '100%',
      marginBottom: theme.spacing(3),
      paddingBottom:
        pathname === '/app/dashboard' ? theme.spacing(0) : theme.spacing(3),
      paddingTop:
        pathname === '/app/dashboard' ? theme.spacing(0) : theme.spacing(3)
    }
  }));

  const classes = useStyles();

  // ---Desmond-Fetching-Activity-lOG--From-Database---//
  const activityLog = async (queries) => {
    const query = queries? `?pageNo=${queries.pageNo || 1}&rows=${queries.rows}`: ''
    api
      .get(`${config.rootUrl}/admin/activities${query}`, {
        headers: {
          Authorization: `Bearer ${storage.getToken()}`
        }
      })
      .then(({ data: isData }) => {
        setData(isData.data);
        setPagination(isData.pagination);
      })
      .catch(error => {
        console.log(error);
      });
  };

  useEffect(() => {
    const { search } = location;
    const queries = qs.parse(search, { ignoreQueryPrefix: true });
    activityLog(queries);
    console.log("queries", queries);
  // eslint-disable-next-line no-sparse-arrays
  }, [,location]);

  // ---Desmond-Fetching-Activity-lOG--From-Database---//

  // useEffect(() => {
  //   const { search } = location;
  //   const queries = qs.parse(search, { ignoreQueryPrefix: true });
  //   axiosGetActivity(queries);
  // }, [location, axiosGetActivity]);
  // const { data, pagination } = userActivityList;
  // console.log('data', data);
  return (
    // Embedded on the dashboard, this inner Page's title wins the tab, so it
    // must not say anything else there (ISSUE-0350).
    <Page
      className={classes.root}
      title={pathname === '/app/dashboard' ? 'Dashboard' : 'Activity Log'}
    >
      <Box>
        {pathname === '/app/activity-log' && <Toolbar />}
        {pathname === '/app/dashboard' && (
          <Card>
            <CardHeader title="Activity Log" />
            <Divider />
          </Card>
        )}
        <Box>
          <Results activities={data} pagination={pagination} />
        </Box>
      </Box>
    </Page>
  );
};

// ActivityLogView.propTypes = {
//   axiosGetActivity: PropTypes.func,
//   userActivityList: PropTypes.object
// };

const mapStateToProps = (/* state , ownProps */) => {
  return {
    // alertSnackbar: state.alertSnackbar,
    // userActivityList: state.userActivity
  };
};

const { setOpen, setMessage, setSeverity } = alertSnackbarActions;
// const { axiosGetActivity } = axiosActions;

const mapDispatchToProps = {
  setOpen,
  setMessage,
  setSeverity
  // axiosGetActivity
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogView);
